import React, { forwardRef, ReactNode } from 'react';
import {
  AccordionPanel as ChakraAccordionPanel,
  AccordionPanelProps,
} from '@chakra-ui/react';

interface Props extends Omit<AccordionPanelProps, `css`> {
  children: ReactNode;
}

export const AccordionPanel = forwardRef<HTMLDivElement, Props>(
  ({ children }, ref): JSX.Element => {
    return <ChakraAccordionPanel ref={ref}>{children}</ChakraAccordionPanel>;
  }
);
export type { Props as AccordionPanelProps };
